import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import withAuthorization from '../../hoc/withAuthorization';
import LargePaper from '../../components/Layout/LargePaper';
import stylesDefault from '../../constants/stylesDefault';
import { getBikes } from '../../store/bikes/actions';
import RentTable from '../../components/Rent/RentTable';
import { getRenters } from '../../store/renters/actions';
import { getSites } from '../../store/sites/actions';
import {resetRents} from "../../store/rents/actions";

const styles = () => ({
  addButton: {
    position: 'fixed',
    display: 'flex',
    justifyContent: 'center',
    bottom: '3vh',
    right: '3vh',
  },
});

export class RentsPage extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
  };

  state = {};

  constructor(props, context) {
    super(props, context);
    this.props.resetRents();
  }

  static getDerivedStateFromProps(props) {
    let newState = null;
    if (
      props.authUser
      && props.roles
      && props.errorBikes === null
      && props.errorSites === null
      && props.errorRenters === null
    ) {
      const role = props.roles[props.authUser.uid];
      if (!props.bikes && !props.pendingBikes) {
        props.getBikes(props.authUser.ma, role);
      }
      if (!props.renters && !props.pendingRenters) {
        props.getRenters(props.authUser.ma, role);
      }
      if (!props.sites && !props.pendingSites) {
        props.getSites(props.authUser.ma, role);
      }
    }
    return newState;
  }

  render() {

    return (
      <LargePaper>
        <h1 style={stylesDefault.title}>Locations</h1>
        <RentTable
          bikes={this.props.bikes}
          sites={this.props.sites}
          renters={this.props.renters}
          pending={this.props.pending}
        />
      </LargePaper>
    );
  }
}

const authCondition = authUser => !!authUser;

const mapStateToProps = state => ({
  pending: state.bikes.pending
  || state.renters.pending
  || state.sites.pending,
  bikes: state.bikes.content,
  sites: state.sites.content,
  renters: state.renters.content,
  pendingBikes: state.bikes.pending,
  pendingSites: state.sites.pending,
  pendingRenters: state.renters.pending,
  errorBikes: state.bikes.error,
  errorSites: state.sites.error,
  errorRenters: state.renters.error
});

export default compose(
  withAuthorization(authCondition),
  connect(mapStateToProps, {
    getBikes, getRenters, getSites, resetRents
  }),
  withStyles(styles),
)(RentsPage);



// WEBPACK FOOTER //
// ./src/containers/RentsPage/RentsPage.jsx